import { EmployeeCostSectionTypeDTO } from "src/models/employee-cost-section-type/employee-cost-section-type-dto";
import { EmployeeCostSectionTypeSTO } from "src/models/employee-cost-section-type/employee-cost-section-type-sto";
import { BaseApiService } from "../base";

export class EmployeeCostSectionTypeApiService extends BaseApiService<
  EmployeeCostSectionTypeDTO,
  EmployeeCostSectionTypeSTO
> {
  constructor() {
    super({
      servicePath: "/EmployeeCostSectionTypes",
      loadItemsPath: "/GetEmployeeCostSectionTypes",
      saveItemsPath: "/SaveEmployeeCostSectionTypes",
    });
  }
}
